module.exports = __webpack_public_path__ + "img/xddqsea-currency-guide-cn.83600e03.png";